// Closing call to action at the bottom of signed-out pages.
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import GoogleButton from './GoogleButton';

export default function CtaBand({
  title = 'Start processing videos for free',
  text = '60 free minutes every month. No credit card needed.',
  children,
}) {
  return (
    <section className="mk-section">
      <div className="mk-container">
        <div className="mk-cta">
          <h2 className="mk-h2">{title}</h2>
          <p className="mk-lead">{text}</p>
          <div className="mk-actions mk-actions--center">
            {children || (
              <>
                <Link to="/signup" className="mk-btn mk-btn--primary">
                  Get started free <FontAwesomeIcon icon={faArrowRight} className="mk-btn-arrow" />
                </Link>
                <GoogleButton />
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
